import { render, staticRenderFns } from "./MessageShow.vue?vue&type=template&id=e07f0298&"
import script from "./MessageShow.vue?vue&type=script&lang=js&"
export * from "./MessageShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports